import type { ElementType, HTMLAttributes, ReactNode } from "react";

type Props = HTMLAttributes<HTMLElement> & {
	children: ReactNode;
	/** Extra classes; shell is always `.wi-card`. */
	className?: string;
	/** Element type — default `div`. */
	as?: ElementType;
	/** Enable −1px hover lift (interactive/share containers only). */
	interactive?: boolean;
};

/**
 * Bounded-object shell (`.wi-card`) — `wi-border` hairline, surface fill, 24px pad, no drop shadow.
 * Use only for interactive/share containers (poll-live rows, FAQ, results, create form); not for layout sections.
 */
export function Card({
	children,
	className = "",
	as: Tag = "div",
	interactive = false,
	...rest
}: Props) {
	return (
		<Tag
			className={["wi-card", interactive ? "wi-card-interactive" : "", className]
				.filter(Boolean)
				.join(" ")}
			data-interactive={interactive ? "" : undefined}
			{...rest}
		>
			{children}
		</Tag>
	);
}
